<template>
  <div>
    <v-dialog v-model="confirmDialog" max-width="300px">
      <div class="text-center">
        <v-sheet
          class="px-7 pt-7 pb-4 mx-auto text-center d-inline-block"
          color="blue-grey darken-3"
          dark
        >
          <div class="grey--text text--lighten-1 text-body-2 mb-4">
            {{
              $t(
                'Todos os cadastros que utilizam essa Classe serão alterados, deseja continuar?'
              )
            }}
          </div>

          <v-btn class="ma-1" color="grey" text @click="confirmDialog = false">
            {{ $t('Não') }}
          </v-btn>

          <v-btn class="ma-1" color="#B14949" text @click="submit">
            {{ $t('Sim') }}
          </v-btn>
        </v-sheet>
      </div>
    </v-dialog>

    <v-dialog v-model="alterDialog" max-width="300px">
      <div class="text-center">
        <v-sheet
          class="px-7 pt-7 pb-4 mx-auto text-center d-inline-block"
          color="blue-grey darken-3"
          dark
        >
          <div class="grey--text text--lighten-1 text-body-2 mb-4">
            {{ $t('Os dados informados não serão salvos, deseja continuar?') }}
          </div>

          <v-btn class="ma-1" color="grey" text @click="alterDialog = false">
            {{ $t('Não') }}
          </v-btn>

          <v-btn class="ma-1" color="#B14949" text @click="closeDialog">
            {{ $t('Sim') }}
          </v-btn>
        </v-sheet>
      </div>
    </v-dialog>

    <v-dialog v-model="deleteDialog" max-width="300px">
      <div class="text-center">
        <v-sheet
          class="px-7 pt-7 pb-4 mx-auto text-center d-inline-block"
          color="blue-grey darken-3"
          dark
        >
          <div class="grey--text text--lighten-1 text-body-2 mb-4">
            {{ $t('Tem certeza de que deseja excluir esta classe?') }}
          </div>

          <v-btn
            :disabled="loading"
            class="ma-1"
            color="grey"
            text
            @click="deleteDialog = false"
          >
            Cancelar
          </v-btn>

          <v-btn
            :loading="loading"
            class="ma-1"
            color="error"
            text
            @click="remove"
          >
            {{ $t('Excluir') }}
          </v-btn>
        </v-sheet>
      </div>
    </v-dialog>

    <v-form class="form" ref="firstForm" lazy-validation>
      <v-row class="ma-0" dense align="center">
        <v-col cols="12" sm="7">
          <label class="label ml-1">{{ $t('Selecione') }}</label>
          <v-autocomplete
            hide-details="auto"
            append-icon="mdi-chevron-down"
            v-model="checklistItemClassId"
            :items="checklistItemClasses"
            item-text="name"
            item-value="id"
            class="primary-input"
            :loading="loading"
            @change="selectedChecklisItemClass"
            outlined
          >
            <template v-slot:selection="{ item }">
              <span class="text-caption">
                {{ $t(item.name) }}
              </span>
            </template>

            <template v-slot:item="{ item }">
              <span class="text-caption">
                {{ $t(item.name) }}
              </span>
            </template>
          </v-autocomplete>
        </v-col>
        <v-col cols="12" sm="5">
          <label class="label">{{ $t('Classe') }}</label>
          <v-text-field
            hide-details="auto"
            v-model="currentChecklistItemClass.name"
            :rules="[
              (v) => !this.applyRules || !!v || 'Classe requerida',
              (v) =>
                !this.applyRules ||
                (v && v.length <= 128) ||
                'Classe deve ter no máximo 128 caracteres',
            ]"
            class="primary-input"
            outlined
          >
            <template #message="{ message }">
              {{ $t(message) }}
            </template>
          </v-text-field>
        </v-col>
        <v-col cols="12" class="d-flex justify-end">
          <v-switch
            inset
            class="mr-2"
            hide-details="auto"
            v-model="currentChecklistItemClass.isPattern"
            :label="$t('Padrão')"
            color="#BBCF20"
            :disabled="userType > 0"
          >
          </v-switch>
        </v-col>
      </v-row>

      <v-row class="justify-center ma-0 pa-0 hidden-md-and-up" no-gutters>
        <v-col cols="6">
          <v-btn @click="close" class="secondary-button" depressed>
            Cancelar
          </v-btn>
        </v-col>
        <v-col cols="6">
          <v-btn
            class="primary-button"
            depressed
            @click="callConfirmDialog"
            :loading="loading"
          >
            {{ $t(buttonText) }}
          </v-btn>
        </v-col>
        <v-btn
          class="quaternary-button"
          v-if="isEditing && userType < 2"
          @click="deleteChecklistItemClass"
          depressed
          color="#B14949"
        >
          {{ $t('Remover') }}
        </v-btn>
      </v-row>
      <v-row class="ma-0 justify-center hidden-sm-and-down">
        <v-btn @click="close" class="mt-3 quaternary-button" depressed>
          Cancelar
        </v-btn>
        <v-btn
          v-if="isEditing && userType < 2"
          @click="deleteChecklistItemClass"
          class="ml-3 mt-3 quaternary-button"
          depressed
          color="#B14949"
        >
          {{ $t('Remover') }}
        </v-btn>
        <v-btn
          color="#426483"
          class="ml-3 mt-3 secondary-button"
          depressed
          @click="callConfirmDialog"
          :loading="loading"
        >
          {{ $t(buttonText) }}
        </v-btn>
      </v-row>
    </v-form>
  </div>
</template>

<style scoped>
.v-application .primary--text {
  color: #707070 !important;
  caret-color: #707070 !important;
}

@media (max-width: 460px) {
  #buttons {
    margin-left: 15px;
  }
}
</style>

<script>
import ApiService from '../../../../../services/ApiService'

export default {
  components: {},

  async created() {
    this.institutionId = JSON.parse(localStorage.getItem('institution')).id
    this.userType = JSON.parse(localStorage.getItem('institution')).userType
    this.getAllChecklistItemClasses()
  },

  data: () => ({
    errorMessage: '',
    applyRules: true,
    isEditing: false,
    confirmDialog: false,
    alterDialog: false,
    deleteDialog: false,
    dialogKey: false,
    loading: false,
    checklistItemClassesLoading: false,
    error: false,
    userType: null,
    checklistItemClasses: [],
    checklistItemClassId: 0,
    currentChecklistItemClass: {
      id: 0,
      name: '',
    },
    nameRules: [],
    apiService: new ApiService(),
  }),

  methods: {
    close() {
      if (this.changedData) {
        this.alterDialog = true
      } else {
        this.$router.go()
      }
    },

    closeDialog() {
      this.changedData = false
      this.alterDialog = false
      this.close()
    },

    callConfirmDialog() {
      if (this.isEditing && this.$refs.firstForm.validate()) {
        this.confirmDialog = true
      } else {
        this.submit()
      }
    },

    selectedChecklisItemClass() {
      const checklisItemClass = this.checklistItemClasses.find(
        (itemClass) => itemClass.id === this.checklistItemClassId
      )
      if (checklisItemClass.id > 0) {
        this.isEditing = true
        this.currentChecklistItemClass = checklisItemClass
        this.applyRules = true
      } else {
        this.currentChecklistItemClass = new Object()
        this.isEditing = false
      }
    },

    deleteChecklistItemClass() {
      this.deleteDialog = true
      this.dialogKey = !this.dialogKey
    },

    async getAllChecklistItemClasses() {
      this.checklistItemClassesLoading = true
      await this.apiService
        .get(`checklistItemClass/list/${this.institutionId}`)
        .then((response) => {
          this.checklistItemClasses = response.content
          if (this.userType > 0) {
            this.checklistItemClasses = this.checklistItemClasses.filter(
              (x) => !x.isPattern
            )
          }
          this.checklistItemClasses.unshift({
            id: 0,
            name: 'Nova Classe',
          })
          this.checklistItemClassesLoading = false
        })
        .catch((err) => {
          this.errorMessage = err.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })
    },

    async submit() {
      if (this.$refs.firstForm.validate()) {
        this.loading = true
        this.confirmDialog = false

        const checklistItemClass = {
          id: this.currentChecklistItemClass.id,
          name: this.currentChecklistItemClass.name,
          isPattern: this.currentChecklistItemClass.isPattern,
          institutionId: this.institutionId,
        }

        let url = 'checklistItemClass/add'

        if (this.isEditing) {
          url = 'checklistItemClass/edit'
        }

        await this.apiService
          .post(url, checklistItemClass)
          .then(() => {
            this.reset()
            this.closeDialog()
          })
          .catch((err) => {
            this.errorMessage = err.body.message
            this.error = true

            setTimeout(() => {
              this.error = false
            }, 4000)
          })

        this.loading = false
        this.changedData = false
        this.isEditing = false
        this.applyRules = true
      }
    },

    async remove() {
      this.loading = true

      await this.apiService
        .delete('checklistItemClass/delete', this.currentChecklistItemClass)
        .then(() => {
          this.loading = false
          this.deleteDialog = false
          this.reset()
        })
        .catch((err) => {
          this.errorMessage = err.message
          this.error = true
          this.deleteDialog = false
          setTimeout(() => {
            this.error = false
          }, 4000)
        })
      this.loading = false
      this.changedData = false
      this.isEditing = false
      this.applyRules = true
    },

    reset() {
      this.applyRules = false
      this.checklistItemClassId = 0
      this.currentChecklistItemClass.id = 0
      this.currentChecklistItemClass.name = ''
      this.getAllChecklistItemClasses()
    },
  },

  computed: {
    buttonText() {
      if (this.isEditing) {
        return 'Atualizar'
      } else {
        return 'Adicionar'
      }
    },
  },

  watch: {
    currentChecklistItemClass: {
      deep: true,
      handler() {
        this.changedData = true
      },
    },
  },
}
</script>
